// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.supportFoorter_supportFooter__UX8Sd {
    display: flex;
    width: calc(100% - 55px);
    padding: 0px 0px 0 82px;
    align-items: center;
    gap: 4px;

    font-family: "Bosch Sans", sans-serif !important;

    a {
        color: #00629a;
        text-decoration: underline;
    }

}`, "",{"version":3,"sources":["webpack://./src/componentes/supportFooter/supportFoorter.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;;IAER,gDAAgD;;IAEhD;QACI,cAAc;QACd,0BAA0B;IAC9B;;AAEJ","sourcesContent":[".supportFooter {\n    display: flex;\n    width: calc(100% - 55px);\n    padding: 0px 0px 0 82px;\n    align-items: center;\n    gap: 4px;\n\n    font-family: \"Bosch Sans\", sans-serif !important;\n\n    a {\n        color: #00629a;\n        text-decoration: underline;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"supportFooter": `supportFoorter_supportFooter__UX8Sd`
};
export default ___CSS_LOADER_EXPORT___;
